/** @fileoverview @suppress {undefinedVars} */

import * as exports from '../core/blockly.js';
$['__chunk_blockly'] = exports;
